export const BLE_CONNECTION_TYPE = 'bleConnectionType';
export const DEVICE_TYPE = 'deviceType';
export const SUCCESS_FWU_COUNT = 'successFwuCount';
export const GET_FEATURE_TYPE = 'getFeatureType';
